/**
 * Helpers for the cookie consent banner.
 *
 * These are intentionally module-scope (immutable, no closure capture) so they
 * never need to appear in React useEffect/useCallback dependency arrays.
 * Some static-analysis tools incorrectly flag them as "missing deps" — moving
 * them out of the component file makes that signal go away cleanly.
 */

export const COOKIE_STORAGE_KEY = "electrocase_cookie_consent_v1";

/**
 * Dev-only logger. Stripped from production bundles when bundlers apply
 * dead-code elimination based on NODE_ENV.
 */
export const devWarn = (msg, err) => {
    if (process.env.NODE_ENV !== "production") {
        console.warn(msg, err);
    }
};

/**
 * Safe localStorage read — returns null on any failure (private mode, SSR, quota).
 */
export function readConsent() {
    try {
        return localStorage.getItem(COOKIE_STORAGE_KEY);
    } catch (err) {
        devWarn("[CookieConsent] localStorage read failed:", err);
        return null;
    }
}

/**
 * Safe localStorage write — swallows failures (private mode etc.).
 * Stores ONLY the user's RGPD choice ("granted"|"denied"), NOT sensitive data.
 */
export function writeConsent(state) {
    try {
        localStorage.setItem(COOKIE_STORAGE_KEY, state);
    } catch (err) {
        devWarn("[CookieConsent] Failed to persist consent choice:", err);
    }
}

/**
 * Push consent state to Google Consent Mode v2.
 */
export function applyConsentToGtag(state) {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("consent", "update", {
        ad_storage: state,
        ad_user_data: state,
        ad_personalization: state,
        analytics_storage: state,
    });
}
